/**
 * This module exists as a source for the fonts used for typed signature creation.
 */

type FontConfig = {
  font: string;
  /**
   * When calculating the max font size used for the signature, the padding is used as an override to
   * decrease the height and width of the canvas to account for odd letter spacing, etc.
   *
   * For example, if you had a canvas height of 60, and the font had a padding of 20, the max font size
   * would fit the font in a height of 40px.
   */
  padding: number;
  onlyAutogeneration?: true;
};

export const FONTS_V2: Readonly<FontConfig[]> = Object.freeze([
  {
    font: "FromSkyler",
    padding: 0,
  },
  {
    font: "BethEllen",
    padding: 0,
  },
  {
    font: "Caveat",
    padding: 0,
  },
  {
    font: "Signerica",
    padding: 10,
    onlyAutogeneration: true,
  },
  {
    font: "TamoroScript",
    padding: 0,
    onlyAutogeneration: true,
  },
  {
    font: "Notera2",
    padding: 0,
    onlyAutogeneration: true,
  },
  {
    font: "SignaturaMonoline",
    padding: 0,
    onlyAutogeneration: true,
  },
  {
    font: "JustMeAgainDownHere",
    padding: 0,
    onlyAutogeneration: true,
  },
  {
    font: "SnowWithVibur",
    padding: 0,
    onlyAutogeneration: true,
  },
  {
    font: "CaveatBrush",
    padding: 0,
    onlyAutogeneration: true,
  },
  {
    font: "CoveredByYourGrace",
    padding: 0,
  },
  {
    font: "CastroScript",
    padding: 0,
  },
]);

const FONTS: Readonly<FontConfig[]> = Object.freeze([
  {
    font: "FromSkyler",
    padding: 10,
  },
  {
    font: "BethEllen",
    padding: 10,
  },
  {
    font: "Caveat",
    padding: 15,
  },
  {
    font: "Signerica",
    padding: 10,
    onlyAutogeneration: true,
  },
  {
    font: "TamoroScript",
    padding: 0,
    onlyAutogeneration: true,
  },
  {
    font: "Notera2",
    padding: 0,
    onlyAutogeneration: true,
  },
  {
    font: "SignaturaMonoline",
    padding: 0,
    onlyAutogeneration: true,
  },
  {
    font: "JustMeAgainDownHere",
    padding: 0,
    onlyAutogeneration: true,
  },
  {
    font: "SnowWithVibur",
    padding: 10,
    onlyAutogeneration: true,
  },
  {
    font: "CaveatBrush",
    padding: 15,
    onlyAutogeneration: true,
  },
  {
    font: "CoveredByYourGrace",
    padding: 10,
  },
  {
    font: "CastroScript",
    padding: 10,
  },
]);

export default FONTS;
